import * as React from "react";
function SvgReactions(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={13}
        cy={16}
        r={12}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M16 27.61a12 12 0 100-23.22"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path d="M15.92 12h.3A2.69 2.69 0 0118 16.22a55.85 55.85 0 01-4.88 5.67.33.33 0 01-.5 0s-3.92-4-4.75-5.67-.18-4 1.8-4.19h.3a3 3 0 012.89 2.31.08.08 0 00.15 0A3 3 0 0115.92 12m0-2a5 5 0 00-3 1 5 5 0 00-3-1h-.51a4.3 4.3 0 00-3.31 2.25 5.3 5.3 0 000 4.85c.9 1.81 4.32 5.37 5.07 6.15a2.33 2.33 0 003.42 0 53.68 53.68 0 005.13-6 5 5 0 00.22-4.8A4.35 4.35 0 0016.43 10h-.51z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgReactions);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
